import Storefront from '../../src/legacy/Storefront';
export default Storefront;
